import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupDivision = () => {
    //page hook
    const { t } = useTranslation();

    return {
        division_name: Yup.string().required(
            t("validation.required", {
                name: t("page.division_name"),
            })
        ),
    };
};
